import { browserSupportMiddleware } from '@/shared/middleware/browserSupport'

export default browserSupportMiddleware
